@if (bannerComponent$ | async; as bannerComponent) {
    <ng-container *msComponentProxy="bannerComponent" />
}
